import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-head-choices',
  templateUrl: './order-head-choices.component.html',
  styleUrls: ['./order-head-choices.component.css']
})
export class OrderHeadChoicesComponent implements OnInit {
    orderInternalNo;

    public grid?: GridOptions;

    constructor(private stateService: StateService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private loadGrid() {
        if (!!this.orderInternalNo) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId('w_orderheadchoices_grid')
                    .setLoadDataFunction({
                        method: 3744,
                        parameters: { order_internal_no: this.orderInternalNo }
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
